module.exports = __webpack_public_path__ + "static/img/address.5dd1238.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aboutUs/address.png
// module id = nVzj
// module chunks = 2